//Function moved to a separate module so it can be mocked in Jest 
//for unit testing, without Jest complaining about the import.meta object.

export const getEnvVar = (key, defaultValue = '') => {
    return import.meta.env[key] || defaultValue;
  };